import * as i0 from "@angular/core";
export class AgentSidePanelComponent {
}
AgentSidePanelComponent.ɵfac = function AgentSidePanelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSidePanelComponent)(); };
AgentSidePanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSidePanelComponent, selectors: [["ycn-agent-side-panel"]], decls: 0, vars: 0, template: function AgentSidePanelComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
